<div class="modal" *ngIf="showModal" [class.show]="showModal">
  <div class="overlay active" (click)="onOverlayClicked($event)">
    <div class="dialog" (click)="onDialogClicked($event)">
      <div class="modal normal modal-cj-bike-cilindrada" id="session-dialog" style="display: block;">
        <span id="btnSessionCancel" class="icon icon-cancel" (click)="onCloseClicked()"></span>
        <div class="modal-wrapper">
          <div class="title">
            <p class="text-05-d-regular text-03-m-regular white">
              La sesión caduca si estás mucho tiempo sin actividad
            </p>
          </div>
          <a class="btn solid-secondary close-modal-trigger text-08-d-regular" style="cursor:pointer"
             (click)="onOkayClicked()" id="sessionOkButton">OK</a>
        </div>
      </div>
    </div>
  </div>
</div>
